<template>
    <empty  style="height: 100vh;">
        <loading size="24px" slot="description">信息处理中...</loading>
    </empty>
</template>
<script>
    import {mapMutations} from 'vuex';
    import {Empty,Loading} from 'vant';
    import { Base64 } from 'js-base64';
    export default {
        props:['authinfo','redirecturl'],
        components:{
            Empty,
            Loading
        },
        methods:{
            ...mapMutations([
                'setUserInfo'
            ]),
            handleAuthInfo:function(){
                let authinfo = Base64.decode(this.authinfo);
                let redirecturl = Base64.decode(this.redirecturl);

                // if(redirecturl.indexOf('movecloud.cn') === -1)
                // {
                //     window.location.replace(redirecturl)
                //     return ;
                // }
                // let token = this.cf.getToken();  
                // if(token){
                //     window.location.replace(redirecturl)
                //     return ;
                // }
                try {
                    authinfo    =   JSON.parse(authinfo)
                    this.setUserInfo(authinfo);
                    window.location.replace(redirecturl)
                }catch (e) {
                    console.log(e)
                }



                //如果5s中未处理成功 跳转到主页
                setTimeout(()=>{
                    this.$toast.fail("数据处理失败")
                    wx.miniProgram.reLaunch({
                        url:'/pages/index/index'
                    });
                },5e3)

            }
        },
        mounted() {
            this.$nextTick(()=>{
                this.handleAuthInfo();
            })
        }
    }
</script>
